import slider1 from "../images/slide-1.jpg";
import slider2 from "../images/slider-2.jpg";
import groceryBanner from "../images/grocery-banner.png";
import groceryBanner2 from "../images/grocery-banner-2.jpg";
import groceries1 from "../images/assortment-citrus-fruits.png";
import bannerDeal1 from "../images/ad-banner-2.jpg";
import categoryAtta from "../images/category-atta-rice-dal.jpg";
import categoryBaby from "../images/category-baby-care.jpg";
import categoryBakery from "../images/category-bakery-biscuits.jpg";
import categoryChicken from "../images/category-chicken-meat-fish.jpg";
import categoryCleaning from "../images/category-cleaning-essentials.jpg";
import categoryDairy from "../images/category-dairy-bread-eggs.jpg";
import categoryInstant from "../images/category-instant-food.jpg";
import categorySnack from "../images/category-snack-munchies.jpg";
import categoryTea from "../images/category-tea-coffee-drinks.jpg";
import clock from "../images/clock.svg";
import gift from "../images/gift.svg";
import package1 from "../images/package.svg";
import refresh from "../images/refresh-cw.svg";

import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ProductItem from "../ProductList/ProductItem";
import Slider from "react-slick";
import { Slide, Zoom } from "react-awesome-reveal";
import { MagnifyingGlass } from "react-loader-spinner";
import FAQ from "./FooterElements/Faq";

const categories = [
  { image: categoryDairy, title: "Aliments et Laitiers" },
  { image: categoryBakery, title: "Gourmandises" },
  { image: categoryAtta, title: "Condiments" },
  { image: categoryInstant, title: "Aperitifs et pain" },
  { image: categoryTea, title: "Boissons" },
  { image: categorySnack, title: "Promotions" },
];

const partners = [
  { image: slider1, title: "Vins libanais" },
  { image: groceries1, title: "Fruits et legumes" },
  { image: categoryBakery, title: "Gourmandises" },
  { image: categoryAtta, title: "Condiments" },
  { image: categoryTea, title: "Cafe et boissons" },
  { image: categoryDairy, title: "Aliments laitiers" },
  { image: categoryCleaning, title: "Entretien" },
  { image: categoryBaby, title: "Bebe" },
  { image: categoryChicken, title: "Volaille et poisson" },
  { image: slider2, title: "Livraison offerte" },
];

const getCartCount = () => {
  try {
    const raw = window.localStorage.getItem("almoune_cart_cache");
    if (!raw) return 0;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed.items)
      ? parsed.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
      : 0;
  } catch { return 0; }
};

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [cartCount, setCartCount] = useState(getCartCount());

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    const updateCart = () => setCartCount(getCartCount());
    window.addEventListener("cart-updated", updateCart);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("cart-updated", updateCart);
    };
  }, []);

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    initialSlide: 1,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 900, settings: { slidesToShow: 3, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
    autoplay: true,
    autoplaySpeed: 2500,
  };

  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
  }, []);

  return (
    <div>
      <div>
        {loaderStatus ? (
          <div className="loader-container">
            <MagnifyingGlass visible={true} height="100" width="100" ariaLabel="magnifying-glass-loading" wrapperStyle={{}} wrapperclassName="magnifying-glass-wrapper" glassColor="#c0efff" color="#0aad0a" />
          </div>
        ) : (
          <>
            <Link
              to="/ShopCart"
              aria-label="Voir le panier"
              style={{
                position: "fixed",
                right: "22px",
                bottom: "140px",
                zIndex: 999,
                width: "52px",
                height: "52px",
                borderRadius: "50%",
                background: "#0aad0a",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 24px rgba(10, 173, 10, 0.28)",
                textDecoration: "none",
              }}
            >
              <span style={{ position: "absolute", top: "-6px", right: "-2px" }} className="badge rounded-pill bg-dark">
                {cartCount}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                <line x1={3} y1={6} x2={21} y2={6} />
                <path d="M16 10a4 4 0 0 1-8 0" />
              </svg>
            </Link>

            <div className="scroll-to-top">
              <button onClick={scrollToTop} className={`scroll-to-top-button ${isVisible ? "show" : ""}`}>↑</button>
            </div>

            {/* Promotion bar - nouveau client */}
            <div className="gw-welcome-bar">
              <div className="container d-flex flex-wrap justify-content-center align-items-center gw-welcome-inner">
                <span className="gw-welcome-badge">Nouveau client ?</span>
                <span className="gw-welcome-text">
                  Livraison <strong>OFFERTE</strong> &amp; <strong>-10%</strong> dès 39€ d'achats.
                </span>
                <span className="gw-welcome-code">
                  Avec le code&nbsp;: <strong>BIENVENUE2026</strong>
                </span>
              </div>
            </div>

            <section className="hero-section">
              <div className="container mt-8">
                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                  <div className="carousel-inner rounded-4 overflow-hidden">
                    <div className="carousel-item active">
                      <div style={{ background: `linear-gradient(90deg, rgba(19, 38, 24, 0.82) 0%, rgba(19, 38, 24, 0.28) 55%, rgba(19, 38, 24, 0.05) 100%), url(${slider1}) no-repeat`, backgroundSize: "cover", backgroundPosition: "center", minHeight: "420px" }}>
                        <div className="gw-hero-caption">
                          <span className="badge text-bg-warning gw-badge-warning">Epicerie orientale</span>
                          <h1 className="gw-hero-title">Almoune <br /> Produits libanais et orientaux</h1>
                          <p className="gw-hero-text">
                            Decouvrez une epicerie orientale riche en produits du quotidien.
                          </p>
                          <Link to="/Shop" className="btn btn-dark gw-hero-btn mt-3"><i className="feather-icon icon-arrow-right me-2" />Decouvrir la boutique</Link>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div style={{ background: `linear-gradient(90deg, rgba(19, 38, 24, 0.82) 0%, rgba(19, 38, 24, 0.28) 55%, rgba(19, 38, 24, 0.05) 100%), url(${slider2}) no-repeat`, backgroundSize: "cover", backgroundPosition: "center", minHeight: "420px" }}>
                        <div className="gw-hero-caption">
                          <span className="badge text-bg-warning gw-badge-warning">Livraison gratuite a partir de 49 euros</span>
                          <h2 className="gw-hero-title">Vos essentiels <br /> de l'epicerie orientale</h2>
                          <p className="gw-hero-text">
                            Retrouvez les produits les plus recherches comme le cafe Najjar, le pain libanais, les legumes marines et les douceurs orientales, avec la livraison offerte des 49 euros.
                          </p>
                          <Link to="/Shop" className="btn btn-dark gw-hero-btn mt-3">Voir nos produits orientaux <i className="feather-icon icon-arrow-right ms-1" /></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="mt-8">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <Slide direction="down">
                      <div
                        className="rounded-4 p-4 p-lg-5 gw-infos-card"
                      >
                        <div className="row g-4 align-items-center">
                          <div className="col-lg-8">
                            <span className="badge text-bg-success mb-3">Bienvenue chez Almoune</span>
                            <h2 className="mb-3 gw-section-title">Epicerie libanaise et orientale a Evry-Courcouronnes</h2>
                            <p className="mb-2 text-muted gw-section-text">
                              Almoune propose une selection de produits libanais et orientaux :
                              cafe Najjar, boissons Junet, condiments, douceurs Hallab, conserves, fruits secs et specialites de boutique.
                            </p>
                            <p className="mb-0 text-muted gw-section-text">
                              Parcourez la boutique en ligne, preparez votre panier et contactez-nous pour
                              toute question sur les produits, la disponibilite et la livraison locale.
                            </p>
                          </div>
                          <div className="col-lg-4">
                            <div className="bg-white rounded-4 p-4 h-100 shadow-sm">
                              <h3 className="h5 mb-3 gw-section-title">Infos boutique</h3>
                              <p className="mb-2 text-muted"><strong>Adresse :</strong> 2 Pl. du Rouillon, 91000 Evry-Courcouronnes</p>
                              <p className="mb-3 text-muted"><strong>Telephone :</strong> +33 9 81 39 14 33</p>
                              <div className="d-flex flex-wrap gap-2">
                                <Link to="/Shop" className="btn btn-success gw-cta-btn btn-sm">Voir la boutique</Link>
                                <Link to="/AboutUs" className="btn btn-outline-success btn-sm">A propos</Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Slide>
                  </div>
                </div>
              </div>
            </section>

            <section className="mt-8">
              <div className="container">
                <div className="row g-4 align-items-stretch">
                  <div className="col-lg-4 col-md-6 col-12 fade-in-left">
                    <Slide direction="left">
                      <div className="banner gw-banner mb-0 h-100">
                        <div className="position-relative">
                          <img src={groceryBanner} alt="Aliments et produits frais" className="img-fluid rounded-3 w-100 gw-banner-img" style={{ minHeight: "280px", objectFit: "cover" }} />
                          <div className="gw-banner-overlay">
                            <h3 className="mb-1 fw-bold gw-banner-title">Aliments &amp; Produits frais</h3>
                            <p className="gw-banner-sub mb-2">Vos essentiels du quotidien</p>
                            <Link to="/Shop" className="btn btn-success gw-cta-btn">Voir le rayon</Link>
                          </div>
                        </div>
                      </div>
                    </Slide>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 slide-in-top">
                    <Zoom>
                      <div className="banner gw-banner mb-0 h-100">
                        <div className="position-relative">
                          <img src={groceryBanner2} alt="Epicerie orientale et gourmandises" className="img-fluid rounded-3 w-100 gw-banner-img" style={{ minHeight: "280px", objectFit: "cover" }} />
                          <div className="gw-banner-overlay">
                            <h3 className="mb-1 fw-bold gw-banner-title">Epicerie orientale</h3>
                            <p className="gw-banner-sub mb-2">Douceurs, cafe et condiments</p>
                            <Link to="/Shop" className="btn btn-success gw-cta-btn">Voir la boutique</Link>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 fade-in-left">
                    <Slide direction="right">
                      <div className="banner gw-banner mb-0 h-100">
                        <div className="position-relative">
                          <img src={bannerDeal1} alt="Fruits et legumes frais" className="img-fluid rounded-3 w-100 gw-banner-img" style={{ minHeight: "280px", objectFit: "cover", objectPosition: "right center" }} />
                          <div className="gw-banner-overlay">
                            <h3 className="mb-1 fw-bold gw-banner-title">Fruits &amp; Legumes</h3>
                            <p className="gw-banner-sub mb-2">Frais, de saison et pleins de saveurs</p>
                            <Link to="/Shop" className="btn btn-success gw-cta-btn">Voir le rayon</Link>
                          </div>
                        </div>
                      </div>
                    </Slide>
                  </div>
                </div>
              </div>
            </section>

            <section className="my-lg-14 my-8">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-6">
                      <div className="section-head text-center mt-8">
                        <h3 className="h3style gw-kicker">Nos categories</h3>
                        <h2 className="gw-cats-title">Shoppez par rayon</h2>
                        <div className="wt-separator bg-success"></div>
                        <div className="wt-separator2 bg-success"></div>
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    {categories.map((category) => (
                      <div className="col-lg-2 col-md-4 col-6 fade-zoom" key={category.title}>
                        <Zoom>
                          <div className="text-center mb-10">
                            <Link to="/Shop" className="gw-cat-link">
                              <img src={category.image} alt={category.title} className="card-image gw-cat-image" />
                            </Link>
                            <div className="mt-4">
                              <h5 className="fs-6 mb-0 gw-cat-name"><Link to="/Shop" className="text-inherit">{category.title}</Link></h5>
                            </div>
                          </div>
                        </Zoom>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            <ProductItem />

            <section className="my-lg-14 my-8">
              <div className="container" style={{ marginTop: 50 }}>
                <div className="row justify-content-center g-4" style={{ textAlign: "center" }}>
                  <div className="col-md-3 col-sm-6 fade-zoom ">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={refresh} alt="Commande simple sur la boutique Almoune" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Commande simple</h3>
                            <p className="gw-section-text">Ajoutez vos produits au panier et retrouvez rapidement vos indispensables orientaux.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={package1} alt="Large assortiment de produits libanais et orientaux" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Large assortiment</h3>
                            <p className="gw-section-text">Des rayons dedies aux produits laitiers, condiments, boissons, gourmandises et aperitifs.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={gift} alt="Promotions et nouveautes Almoune" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Promotions visibles</h3>
                            <p className="gw-section-text">Nouveautes, meilleures ventes et promos sont mises en avant des la page d'accueil.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={clock} alt="Contact client et assistance boutique" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Contact client direct</h3>
                            <p className="gw-section-text">Le numero +33 9 81 39 14 33 reste visible pour aider rapidement les clients.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                </div>
              </div>
            </section>

            <FAQ />

            <div className="container mb-8">
              <Slider {...settings2}>
                {partners.map((partner) => (
                  <div className="m-1" key={partner.title}>
                    <div className="partner-list">
                      <img src={partner.image} className="img-fluid" style={{ height: "90px", objectFit: "contain" }} alt={partner.title} />
                      <h6 className="card-title mt-2">{partner.title}</h6>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
